import { render, staticRenderFns } from "./IntegralShopGiftTable.vue?vue&type=template&id=d66062c6&scoped=true"
import script from "./IntegralShopGiftTable.vue?vue&type=script&lang=js"
export * from "./IntegralShopGiftTable.vue?vue&type=script&lang=js"
import style0 from "./IntegralShopGiftTable.vue?vue&type=style&index=0&id=d66062c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66062c6",
  null
  
)

export default component.exports